module.exports = __webpack_public_path__ + "img/blue_economy_details.4504ccb5.svg";